import { useEffect, useRef, useState } from 'react'
import { HAVE_WINDOW } from 'src/constants'

export const useElementOnScreen = (options: IntersectionObserverInit) => {
  const containerRef = useRef<HTMLDivElement | null>(null)
  const [isVisible, setIsVisible] = useState(false)
  const [hasBeenViewed, setHasBeenViewed] = useState(false)

  const callbackFunction = (entries: IntersectionObserverEntry[]) => {
    const [entry] = entries

    setIsVisible(entry.isIntersecting)
  }

  useEffect(() => {
    if (!HAVE_WINDOW) {
      return
    }

    const currentRef = containerRef.current
    const observer = new IntersectionObserver(callbackFunction, options)

    if (currentRef) {
      observer.observe(currentRef)
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef)
      }
    }
  }, [options])

  return { containerRef, isVisible, hasBeenViewed, setHasBeenViewed }
}
